<template>
    <div class="tableColCtrl">
        <el-dialog :visible="show" @close="onCloseClick" :title="$t('table_columns_display_btn')" :loading="loading">
            <div class="dialogcontainer">
                <el-tree
                    ref="tree"
                    :data="hereTreeData"
                    show-checkbox
                    node-key="id"
                    default-expand-all
                    :expand-on-click-node="false"
                    :check-strictly="true"
                    @check-change="onTreeCheckChange"
                    @check="onTreeCheckboxCheck"
                    :props="{
                        children: 'childMilestoneBO',
                        label: 'milestoneName'
                    }">
                    <div class="tree-node" slot-scope="{ node, data }">
                        <div class="tree-left" v-html="node.label"></div>
                        <div class="tree-right" v-show="data.childMilestoneBO && data.childMilestoneBO.length > 0">
                            <el-button
                                v-show="calcAllSelected(data)"
                                type="text"
                                size="mini"
                                @click="() => triggerUnSelectAllNode(data)">
                                {{ $t('unselect_all') }}
                            </el-button>
                            <el-button
                                v-show="!calcAllSelected(data)"
                                type="text"
                                size="mini"
                                @click="() => triggerSelectAllNode(data)">
                                {{ $t('select_all') }}
                            </el-button>
                        </div>
                    </div>
                </el-tree>
            </div>
            <template #footer>
                <div class="dialogfooter">
                    <el-button @click="onCloseClick">取消</el-button>
                    <el-button class="wl-green" @click="onSaveClick" :loading="loading">保存</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'

export default {
    name: 'SASTableColumnControl',
    props: {
        show: false,
        treeData: {},
        // onColumnsLoad: {
        //     type: Function,
        //     default: (e) => {}
        // },
        parentPageLoadColumn: {
            type: Function,
            default: (e) => {}
        },
        anyHidden: {
            type: Boolean,
            default: false
        }
    },
    data() {return {
        treeSelectedKeys: [],
        loading: false
    }},
    async mounted() {
        await this.getColumnStatus()
    },
    methods: {
        /**
         * checkbox 被点击的时候触发
         * 处理一些一致性的问题
         * 
         * 不需要处理 “二级有选的，但把一级取消了” 的情况，一级不显示了二级也就都没了
         * @param {*} node 
         * @param {*} curr 
         */
        onTreeCheckboxCheck(node, curr) {
            this.treeData.forEach(v => {
                // 如果二级都没选，想直接选一级，那就把二级全都选上
                if (v.childMilestoneBO.every(vv => !this.treeSelectedKeys.includes(vv.id)) && node.childMilestoneBO !== null) {
                    this.treeSelectedKeys = [...this.treeSelectedKeys, ...v.childMilestoneBO.map(val => val.id)]
                }
                // 如果二级都没选，但一级已经选了，那把一级也取消勾选
                if (v.childMilestoneBO.every(vv => !this.treeSelectedKeys.includes(vv.id)) && node.childMilestoneBO === null) {
                    const findVIdIndex = this.treeSelectedKeys.findIndex(val => val == v.id)
                    if (findVIdIndex > -1) this.treeSelectedKeys.splice(findVIdIndex, 1)
                }
            })
        },
        async onSaveClick() {
            let hiddenColumns = []
            this.treeData.forEach(v => {
                if (!this.treeSelectedKeys.includes(v.id)) {
                    hiddenColumns.push(v.id)
                }
                v.childMilestoneBO.forEach(vv => {
                    if (!this.treeSelectedKeys.includes(vv.id)) {
                        hiddenColumns.push(vv.id)
                    }
                })
            })
            this.loading = true
            await API.common.saveFixColumns({
                siteId: this.getSite.siteId,
                tableKey: 'SAS',
                hiddenColumns
            })

            this.$message({
                type: 'success',
                message: this.$t('msg_success')
            })
            this.parentPageLoadColumn()

            this.loading = false
            this.$emit('update:show', false)
        },
        calcAllSelected(data) {
            if (data.childMilestoneBO === null) {
                return false
            }
            return data.childMilestoneBO.every(v => this.treeSelectedKeys.includes(v.id))
        },
        onTreeCheckChange(node, nodeChecked, childChecked) {
            this.treeSelectedKeys = this.$refs['tree'].getCheckedKeys()
        },
        triggerUnSelectAllNode(data) {
            [data.id, ...data.childMilestoneBO.map(v => v.id)].forEach(v => {
                const find = this.treeSelectedKeys.findIndex(vv => vv == v)
                if (find > -1) this.treeSelectedKeys.splice(find, 1)
            })
        },
        triggerSelectAllNode(data) {
            [data.id, ...data.childMilestoneBO.map(v => v.id)].forEach(v => {
                if (!this.treeSelectedKeys.includes(v)) {
                    this.treeSelectedKeys.push(v)
                }
            })
        },
        async getColumnStatus() {
            this.treeData.forEach(v => {
                if (v.show && !this.treeSelectedKeys.includes(v.id)) {
                    this.treeSelectedKeys.push(v.id)
                }
                v.childMilestoneBO.forEach(vv => {
                    if (vv.show && !this.treeSelectedKeys.includes(vv.id)) {
                        this.treeSelectedKeys.push(vv.id)
                    }
                })
            })
             
            const interval = setInterval(() => {
                if (this.$refs['tree']) {
                    this.$refs['tree'].setCheckedKeys(this.treeSelectedKeys)
                    clearInterval(interval)
                }
            }, 200)
        },
        onCloseClick() {
            this.getColumnStatus()
            this.$emit('update:show', false)
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser'
        }),
        hereTreeData() {
            return this.treeData.map(v => {
                v.disabled = true
                return v
            })
        },
        anyHiddenHere() {
            let hiddenColumns = []
            this.treeData.forEach(v => {
                if (!this.treeSelectedKeys.includes(v.id)) {
                    hiddenColumns.push(v.id)
                }
                v.childMilestoneBO.forEach(vv => {
                    if (!this.treeSelectedKeys.includes(vv.id)) {
                        hiddenColumns.push(vv.id)
                    }
                })
            })
             
            return hiddenColumns.length > 0
        }
    },
    watch: {
        treeSelectedKeys: {
            deep: true,
            handler() {
                if (this.$refs['tree']) this.$refs['tree'].setCheckedKeys(this.treeSelectedKeys)
            }
        },
        anyHiddenHere(v) {
            this.$emit('update:anyHidden', v)
        }
    }
}
</script>
<style scoped>
.el-dialog .el-dialog__header {
    height: 44px;
}
.dialogcontainer {
    height: 60vh;
    overflow-y: scroll;
}
.tree-node {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.tree-node .tree-left {}
.tree-node .tree-right {
    margin-right: 20px;
}
::v-deep .el-tree-node__content .el-tree-node__expand-icon{
    display: none;
}
::v-deep .el-tree-node > .el-tree-node__content > .is-disabled{
    display: none;
}
</style>